<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text">
       {{task}} Stream
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="streamForm" class="form-grid">

      <div class="form-grid-row">
        <app-select-search
          formControlName="streamId" [isrequired]="true" [matcher]="matcher"
          [invalid]="!!(streamForm.get('streamId')?.invalid && (streamForm.get('streamId')?.touched || attemptSave()))"
          [selectItems]="streams" selectTitle="Stream" (selectedItemId)="onStreamreceived($event)">
        </app-select-search>
      </div>

      <div class="form-grid-row">
        <app-select-search
          formControlName="qtyUomId" [isrequired]="true" [matcher]="matcher"
          [invalid]="!!(streamForm.get('qtyUomId')?.invalid && (streamForm.get('qtyUomId')?.touched || attemptSave()))"
          [selectItems]="uoms" selectTitle="Unit">
        </app-select-search>
        
        <mat-form-field appearance="outline">
          <mat-label>Quantity</mat-label>
          <input matInput formControlName="quantity" type="text" (input)="roundOff($event, 99999, 4, 'quantity')">
          <mat-error *ngIf="streamForm.get('quantity')?.hasError('required')">
            Quantity is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-grid-row">
        <app-select-search formControlName="siteUomId" [selectItems]="uoms" selectTitle="Site UOM"></app-select-search>
  
        <!-- SITE WEIGHT -->
        <mat-form-field appearance="outline">
          <mat-label>Site WGT.</mat-label>    
          <input matInput formControlName="siteWeight" type="text" (input)="roundOff($event, 99999, 4, 'siteWeight')"></mat-form-field>
      </div>

      <div class="form-grid-row">
        <app-select-search formControlName="custUomId" [selectItems]="uoms" selectTitle="Cust UOM"
          [isrequired]="statusId === completeStatusId && !isDriverMode"
          [invalid]="!!(streamForm.get('custUomId')?.invalid && (streamForm.get('custUomId')?.touched || attemptSave()))">
        </app-select-search>
    
        <!-- CUST WEIGHT -->
        <mat-form-field appearance="outline">
          <mat-label>Cust WGT.</mat-label>    
          <input matInput formControlName="custWeight" type="text" (input)="roundOff($event, 99999, 4, 'custWeight')">
        </mat-form-field>
      </div>

      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Actual Tons</mat-label>    
          <input matInput formControlName="tons" type="text" (input)="roundOff($event, 99999, 4, 'tons')">
        </mat-form-field>
    
        @if (!isDriverMode){
          <mat-form-field appearance="outline">
            <mat-label>Unit Price</mat-label>    
            <input matInput formControlName="unitPrice" type="text" (input)="roundOff($event, 9999, 4, 'unitPrice')">
            <mat-error *ngIf="streamForm.get('unitPrice')?.hasError('required')">
              Unit Price is required
            </mat-error>
          </mat-form-field>
        }
      </div>
  
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="dialog-footer">
    <button mat-raised-button color="primary" mat-primary (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" mat-primary data-testid="btnaddtStreamSave" (click)="onSave()">Save</button>
  </mat-dialog-actions>
  